'use strict';

// Constructor
var PublicHealthAlerts = function () {
    $('.row.public-health-alerts article').matchHeight();
};

module.exports = PublicHealthAlerts;
